import { render, staticRenderFns } from "./LegendSeparator.vue?vue&type=template&id=452b2728&"
import script from "./LegendSeparator.vue?vue&type=script&lang=js&"
export * from "./LegendSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports